// extracted by mini-css-extract-plugin
module.exports = {"overlay":"HeadToTheAppDialog_overlay___92U6","qr":"HeadToTheAppDialog_qr__Qr4WH"};